import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// import App from "./App";
import AppWrapper from "./App";
import Login from "./Login.js";
import ForgotPassword from "./ForgotPassword.js";
import ResetPassword from "./ResetPassword.js";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute.js";



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/App/*" element={<ProtectedRoute><AppWrapper /></ProtectedRoute>} />
        {/* <Route path="/App/*" element={<ProtectedRoute><App /></ProtectedRoute>} />  */}
        {/* <Route path="/app/*" element={<App />} /> 👈 Notice the `/*` to allow nested routing */}
        {/* <Route path="/app" element={<App />} /> */}
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
 
